export default __webpack_public_path__ + "images/6db179de8562ddd4683658c7b977881c.svg";